
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Link2, PlusCircle } from 'lucide-react';

const AliasManager = ({ isOpen, alias, type, options, onClose, onLink, onAddNew }) => {
  const [selectedValue, setSelectedValue] = useState('');
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newItemName, setNewItemName] = useState(alias);

  const typeLabels = {
    flag: 'Bandeira',
    payment_method: 'Forma de Pagamento',
  };

  const handleLink = () => {
    if (selectedValue) {
      onLink(selectedValue);
      resetState();
    }
  };

  const handleAddNew = async () => {
    if (newItemName.trim()) {
      const createdItem = await onAddNew({ name: newItemName.trim() });
      if (createdItem) {
        onLink(createdItem.name);
      }
      resetState();
    }
  };

  const resetState = () => {
    setSelectedValue('');
    setIsAddingNew(false);
    setNewItemName(alias);
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Link2 className="w-5 h-5 text-blue-400" />
            Vincular "{alias}"
          </DialogTitle>
          <DialogDescription>
            O termo "{alias}" não foi encontrado. Vincule-o a um(a) {typeLabels[type]} existente ou cadastre um novo.
          </DialogDescription>
        </DialogHeader>
        
        {isAddingNew ? (
          <div className="py-4 space-y-4">
            <Label htmlFor="new-item-name">Nome do(a) novo(a) {typeLabels[type]}</Label>
            <Input 
              id="new-item-name"
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              placeholder={`Digite o nome...`}
            />
            <div className="flex justify-end gap-2">
              <Button variant="ghost" onClick={() => setIsAddingNew(false)}>Voltar</Button>
              <Button onClick={handleAddNew}>Salvar e Vincular</Button>
            </div>
          </div>
        ) : (
          <>
            <div className="py-4">
              <Label htmlFor="alias-select">Selecione o(a) {typeLabels[type]} correto(a)</Label>
              <Select onValueChange={setSelectedValue}>
                <SelectTrigger id="alias-select">
                  <SelectValue placeholder={`Selecione um(a) ${typeLabels[type]}...`} />
                </SelectTrigger>
                <SelectContent position="popper" className="max-h-[300px] overflow-y-auto z-[9999]">
                  {options.map((option) => (
                    <SelectItem key={option.id} value={option.name}>
                      {option.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <DialogFooter className="sm:justify-between">
              <Button variant="secondary" onClick={() => setIsAddingNew(true)}>
                <PlusCircle className="w-4 h-4 mr-2" />
                Cadastrar Novo
              </Button>
              <div className="flex gap-2">
                <Button variant="outline" onClick={handleClose}>Cancelar</Button>
                <Button onClick={handleLink} disabled={!selectedValue}>Vincular e Continuar</Button>
              </div>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AliasManager;
